import { render, staticRenderFns } from "./PainelComTabs.vue?vue&type=template&id=132a14c2&scoped=true"
import script from "./PainelComTabs.vue?vue&type=script&lang=js"
export * from "./PainelComTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a14c2",
  null
  
)

export default component.exports